<template>
  <div>
    <el-dialog
      :modal="true"
      class="logout-style"
      :visible.sync="centerDialogVisible"
      width="560px"
      :before-close="cancel"
      center>
      <span class="log-msg-font-style">{{ msg }}</span>
      <span slot="footer" class="dialog-footer">
        <sp-smart-button class="cancel m-right-2" @click="cancel">{{ $t("button.common.cancel") }}</sp-smart-button>
        <sp-smart-button class="ok" :disable="isDisabled" @click="ok">{{ $t("button.common.ok") }}</sp-smart-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SpSmartButton from "@/components/common/sp-smart-button"

export default {
  components:{
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
      centerDialogVisible: this.centerDialogVisibleParam,
      msg: this.msgParam,
    }
  },
  props: {
    centerDialogVisibleParam: {
      type: Boolean,
      default: false
    },
    msgParam: {
      type: String,
      default: null
    },
    isPassParam: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    centerDialogVisibleParam: function (value) {
      this.centerDialogVisible = value
    },
    msgParam(val) {
      this.msg = val
    }
  },
  mounted() {
  },
  methods:{
    cancel () {
      this.$emit("on-cancel", true)
      this.$emit("update:centerDialogVisibleParam", false)
    },
    ok () {
      this.$emit("on-isPassParam", true)
      this.$emit("update:centerDialogVisibleParam", false)
    }
  }
};
</script>
<style scoped>
::v-deep .logout-style .el-dialog__header {
  display: none;
}
.log-msg-font-style {
  text-align: center;
  display: block;
  font-size: 16px;
  white-space: pre-wrap;
}
::v-deep .logout-style .el-dialog--center .el-dialog__footer {
  width: 464px !important;
}
</style>
